import {OVERLAY_DEFAULT_CONFIG} from '@angular/cdk/overlay';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import 'zone.js';
import {bootstrapApplication} from '@angular/platform-browser';
import {provideNoopAnimations} from '@angular/platform-browser/animations';
import {provideRouter, withDisabledInitialNavigation} from '@angular/router';
import {DsIconModule} from '@bmw-ds/components';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {AllCommunityModule, ModuleRegistry, provideGlobalGridOptions} from 'ag-grid-community';
import {WenInterceptor} from './app/auth/oidc/wen-interceptor';
import {AppComponent} from './app/components/app.component';
import {ResponseTimeInterceptorService} from './app/services/response-time-interceptor.service';

provideGlobalGridOptions({theme: 'legacy'});
ModuleRegistry.registerModules([AllCommunityModule]);

bootstrapApplication(AppComponent, {
  providers: [
    // Angular 21 defaults to zoneless change detection; this app still relies on Zone.js
    provideZoneChangeDetection(),
    importProvidersFrom(DsIconModule.forRoot({
      sprite: '/assets/img/custom_icons.svg'
    })),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: WenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResponseTimeInterceptorService,
      multi: true
    },
    // Keep pre-Angular-21 overlay rendering in the global overlay container so frame styles still apply (ISPI-486294)
    {provide: OVERLAY_DEFAULT_CONFIG, useValue: {usePopover: false}},
    provideNoopAnimations(),
    provideRouter([], withDisabledInitialNavigation()),
    provideHttpClient(withInterceptorsFromDi()),
    provideTranslateService({
      loader: provideTranslateHttpLoader(),
      fallbackLang: 'en-US'
    })
  ]
}).catch(err => console.error(err));
